import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { registrationInputMaxLength } from "app/utils/const";
import { useEffect, useState } from "react";
import { IntlShape } from "react-intl";

type Props = {
  handleChange: (id: string, value: string) => void;
  firstName: string;
  lastName: string;
  intl: IntlShape;
  firstNameValidationError: boolean;
  lastNameValidationError: boolean;
};

const FirstNameLastName = ({
  handleChange,
  firstName,
  lastName,
  intl,
  firstNameValidationError,
  lastNameValidationError,
}: Props) => {
  const [errorFirstName, setErrorFirstName] = useState<string>("");
  const [errorLastName, setErrorLastName] = useState<string>("");

  const validateFirstName = (id: string, value: string) => {
    if (value.length < 2) {
      setErrorFirstName(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorFirstName("");
    }
  };

  const validateLastName = (id: string, value: string) => {
    if (value.length < 2) {
      setErrorLastName(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorLastName("");
    }
  };

  useEffect(() => {
    if (firstNameValidationError) {
      validateFirstName("firstName", "");
    }
    if (lastNameValidationError) {
      validateLastName("lastName", "");
    }
  }, [lastNameValidationError, firstNameValidationError]);

  return (
    <div className="form-details__row form-details__row--two-cols">
      <div className="form-details__col">
        <InputWithLabel
          label={intl.formatMessage({
            id: "home-contact-us-input-first-name",
          })}
          inputId={"firstName"}
          value={firstName}
          onValueChange={handleChange}
          key={"firstName"}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: "home-contact-us-input-your-first-name",
          })}
          validateInput={true}
          error={errorFirstName}
          handleValidation={validateFirstName}
        />
      </div>
      <div className="form-details__col">
        <InputWithLabel
          label={intl.formatMessage({
            id: "home-contact-us-input-last-name",
          })}
          inputId={"lastName"}
          value={lastName}
          onValueChange={handleChange}
          key={"lastName"}
          required={true}
          type={"text"}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={intl.formatMessage({
            id: "home-contact-us-input-your-last-name",
          })}
          validateInput={true}
          error={errorLastName}
          handleValidation={validateLastName}
        />
      </div>
    </div>
  );
};

export default FirstNameLastName;
